import React from 'react'
import './project.css'
import He from '../../asset/images/portfolio1.jpg'
import He1 from '../../asset/images/portfolio2.jpg'
import He2 from '../../asset/images/portfolio3.jpg'
import He3 from '../../asset/images/portfolio4.jpg'

function Project() {
  return (
    <section id='project'>
      <h5>My Recent Work</h5>
      <h2> Project</h2>

      <div className="container project_container">
        <article className='project_item'>
          <div className="project_item-images">
            <img src={He} alt="" />
          </div>
          <h3>Panda Commerce </h3>
          <div className="project_item-cta">
          <a href="https://github.com/mhabrar/panda-commerce"  className='btn' >Github</a>
          <a href="https://mhabrar.github.io/panda-commerce/panda.html" className='btn btn-primary'>Live Demo</a>
          </div>
       

          </article>
          <article className='project_item'>
          <div className="project_item-images">
            <img src={He1} alt="" />
          </div>
          <h3>Javascript Calculator</h3>
         <div className="project_item-cta">
         <a href="https://github.com/mhabrar/calculator-" className='btn'>Github</a>
          <a href="https://j92wjj.csb.app/" className='btn btn-primary'>Live Demo</a>
         </div>

          </article>

        <article className='project_item'>
          <div className="project_item-images">
            <img src={He2} alt="" />
          </div>
          <h3>Bank Login Page</h3>
         <div className="project_item-cta">
          <a href="https://github.com/mhabrar/pinoneer--bank" className='btn'>Github</a>
          <a href="https://n2c75m.csb.app/" className='btn btn-primary'>Live Demo</a>

         </div>
          </article>

        <article className='project_item'>
          <div className="project_item-images">
            <img src={He3} alt="" />
          </div>
          <h3>E-School Learn</h3>
          <div className="project_item-cta">
          <a href="http://github.com/mhabrar" className='btn'>Github</a>
          <a href="https://0pzcfr.csb.app/" className='btn btn-primary'>Live Demo</a>

          </div>

          </article>

        
      </div>


    </section>
    
  )
}

export default Project